import React, { ChangeEvent, ReactNode } from "react";
import { FormGroup, Label, Input, FormFeedback, FormText } from "reactstrap";
import { useField } from "formik";
import HelpPopover from "./HelpPopover";
import { ColSize } from "./TextField";

interface Props {
  col?: ColSize;
  name: string;
  label?: string;
  help?: string;
  date?: boolean; // special case with org disable checkbox to send date
  /** Set to make this one entry in an array-valued field rather than a boolean */
  value?: string;
  description?: string | ReactNode;
  disabled?: boolean;
}

export default function CheckboxField(props: Props) {
  const { name, date, label, col, description, help, value } = props;
  const [field, meta, helper] = useField<boolean | string | null>({
    name: name,
    type: "checkbox",
    value,
  });

  const invalid = Boolean(meta.touched && meta.error);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (date) {
      helper.setValue(event.target.checked ? new Date().toISOString() : null);
      return;
    }

    helper.setValue(event.target.checked);
  };

  return (
    <FormGroup className={col && `col-md-${col}`}>
      <div className="form-check">
        <Input
          id={value ? `${field.name}-${value}` : field.name}
          checked={field.checked}
          name={field.name}
          value={value}
          invalid={invalid}
          type="checkbox"
          onChange={value ? field.onChange : handleChange}
          onBlur={field.onBlur}
          disabled={props.disabled}
        />{" "}
        <Label check for={value ? `${field.name}-${value}` : field.name}>
          {label}
        </Label>{" "}
        <HelpPopover id={`${field.name}-${value ?? ""}-help`} text={help} />
        <FormText>{description}</FormText>
        <FormFeedback>{meta.error}</FormFeedback>
      </div>
    </FormGroup>
  );
}
